<template>
    <!-- DRUG CARD TABLE (PACKS AND PIECES IN SEPARATE COLUMNS) -->
    <b-table class="mt-4" striped hover :fields="tableFields" :items="logs" id="drugCardTable">
        <template #cell(date)="data">
            {{ getLocalDate(data.item.created_at, $i18n.locale, true, false) }}
        </template>
        <template #cell(supplier)="data">
            <span v-if="data.item.type === 'put_in'">
                <SupplierField :fieldSupplier="data.item.supplier || []" :fieldArray="data.item.re_supplier" />
            </span>
        </template>
        <template #cell(put_in_packages)="data">
            {{ getDisplayAmount(data.item, 'add', true) }}
        </template>
        <template #cell(put_in_pieces)="data">
            {{ getDisplayAmount(data.item, 'add', false) }}
        </template>
        <template #cell(taken_out_packages)="data">
            {{ getDisplayAmount(data.item, 'remove', true) }}
        </template>
        <template #cell(taken_out_pieces)="data">
            {{ getDisplayAmount(data.item, 'remove', false) }}
        </template>
        <template #cell(client)="data">
            <ResInfoField :fieldArray="data.item.client || []" :logType="data.item.type" />
        </template>
        <template #cell(doctor)="data">
            <ResInfoField :fieldArray="data.item.doctor || []" :logType="data.item.type" />
        </template>
        <template #cell(prescription)="data">
            <ResInfoField :fieldArray="data.item.prescription || []" :logType="data.item.type" />
        </template>
        <template #cell(inventory_check)="data">
            {{ getInventoryCheckValue(data.item) }}
        </template>
        <template #cell(comments)="data">
            {{ getDrugCardCommentCellContent(data.item) }}
        </template>
    </b-table>
</template>

<script>
import ResInfoField from './ResInfoField';
import SupplierField from './SupplierField';
import { getLocalDate } from '@/services/dateService';
import { getDrugCardCommentCellContent } from '@/services/logService';

export default {
    components: {
        ResInfoField,
        SupplierField
    },
    props: {
        logs: {
            type: Array,
            required: true
        },
        layout: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            getDrugCardCommentCellContent,
            getLocalDate
        };
    },
    computed: {
        tableFields() {
            const hasPartialTakeOut =
                true &&
                this.logs.find(
                    log => log.type.match(/^(take_out|reservation)$/) && log.pills_amount && log.pills_amount > 0
                );
            const hasPartialInventory =
                true && this.logs.find(log => log.partial_inventory_amount && log.partial_inventory_amount > 0);
            let fields = [];
            fields.push({ key: 'date', label: this.$t('date'), tdClass: 'align-middle' });
            fields.push({ key: 'supplier', label: this.$t('supplier'), tdClass: 'align-middle' });
            fields.push({
                key: 'put_in_packages',
                label: `${this.$t('amount_added')}\n[${this.$t('packages_short_singular_partitive')}]`,
                tdClass: 'align-middle'
            });
            fields.push({
                key: 'put_in_pieces',
                label: `${this.$t('amount_added')}\n[${this.$t('pieces_short_singular_partitive')}]`,
                tdClass: 'align-middle'
            });
            fields.push({
                key: 'taken_out_packages',
                label: `${this.$t('amount_taken')}\n[${this.$t('packages_short_singular_partitive')}]`,
                tdClass: 'align-middle'
            });
            if (hasPartialTakeOut) {
                fields.push({
                    key: 'taken_out_pieces',
                    label: `${this.$t('amount_taken')}\n[${this.$t('pieces_short_singular_partitive')}]`,
                    tdClass: 'align-middle'
                });
            }
            fields.push({
                key: 'inventory_amount',
                label: `${this.$t('inventory_left')}\n[${this.$t('packages_short_singular_partitive')}]`,
                tdClass: 'align-middle'
            });
            if (hasPartialInventory) {
                fields.push({
                    key: 'partial_inventory_amount',
                    label: `${this.$t('inventory_left')}\n[${this.$t('pieces_short_singular_partitive')}]`,
                    tdClass: 'align-middle'
                });
            }
            fields.push({ key: 'client', label: this.$t('client'), tdClass: 'align-middle' });
            fields.push({ key: 'doctor', label: this.$t('doctor'), tdClass: 'align-middle' });
            fields.push({ key: 'prescription', label: this.$t('prescription'), tdClass: 'align-middle' });
            fields.push({ key: 'user_name', label: this.$t('handler'), tdClass: 'align-middle' });
            if (this.layout.show_inventory_check_column) {
                fields.push({ key: 'inventory_check', label: this.$t('inventory_check'), tdClass: 'align-middle' });
            }
            fields.push({ key: 'comments', label: this.$t('comments'), tdClass: 'align-middle' });
            this.$emit('tableFields', fields);
            return fields;
        }
    },
    methods: {
        // get display amount (depends on log type)
        getDisplayAmount(log, columnType, packs) {
            let output = '';

            if (
                (columnType === 'add' && log.type === 'put_in') ||
                (columnType === 'remove' && log.type.match(/^(take_out|reservation)$/))
            ) {
                output = packs ? log.amount : log.pills_amount;
                // DON'T SHOW CHANGED AMOUNTS FOR INVENTORY CORRECTION
                // } else if (
                //     log.action === 'change' &&
                //     log.amount_changed_packs !== undefined &&
                //     log.amount_changed_pills !== undefined &&
                //     ((columnType === 'add' && !(log.amount_changed_packs < 0 || log.amount_changed_pills < 0)) ||
                //         (columnType === 'remove' && (log.amount_changed_packs < 0 || log.amount_changed_pills < 0)))
                // ) {
                //     output = packs ? Math.abs(log.amount_changed_packs) : Math.abs(log.amount_changed_pills);
            }

            return output;
        },
        // get log's inventory check value
        getInventoryCheckValue(log) {
            if (log.inventory_check !== undefined && log.inventory_check !== null) {
                return log.inventory_check ? this.$t('ok') : this.$t('error');
            } else return '–';
        }
    }
};
</script>
